var exports = {
  "U": "x93eb46d8--5ea810--heart-active",
  "x": "x93eb46d8--5ea810--button",
};

module.exports = exports;
